import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles(theme => ({
  container: {
    display: "flex",
    justifyContent: "space-between",
    margin: theme.spacing(1),
    backgroundColor: "#FFF",
    textAlign: "left",
    [theme.breakpoints.down("xs")]: {
      margin: "initial",
      marginBottom: "20px",
    },
  },
  leftContainer: {
    width: "80%",
  },
  rightContainer: {
    width: "20%",
  },
  deleteButton: {
    font: "normal normal normal 13px/15px Helvetica",
    letterSpacing: "0px",
    color: "#9A9A9A",
    opacity: 1,
    height: 25,
  },
  menuButton: {
    backgroundColor: "#fff",
    letterSpacing: "0px",
    padding: "0px",
    height: "29px",
    width: "100%",
    [theme.breakpoints.down("xs")]: {
      fontSize: "12px",
      height: "25px",
    },
  },
  menuInput: {
    paddingRight: "5px",
  },
  mobileLabels: {
    marginTop: "5px",
    fontSize: "12px",
    color: "#9A9A9A",
    textAlign: "center",
  },
}))

export default styles
